import React from 'react';

const Dashboard = () => (
  <div>
    <h1>Dashboard</h1>
  </div>
);

export default Dashboard;
